import React, { useCallback } from 'react';
import { useApi } from '@deephaven/jsapi-bootstrap';
import { AUTH_HANDLER_TYPE_ANONYMOUS } from "./AuthHandlerTypes.js";
import AuthPluginBase from "./AuthPluginBase.js";
import { UserPermissionsOverrideContext } from "./UserContexts.js";
import { jsx as _jsx } from "react/jsx-runtime";
var permissionsOverrides = {
  canLogout: false
};

/**
 * AuthPlugin that tries to login anonymously. Fails if anonymous login fails
 */
function Component(_ref) {
  var children = _ref.children;
  var dh = useApi();
  var getLoginOptions = useCallback(() => ({
    type: dh.CoreClient.LOGIN_TYPE_ANONYMOUS
  }), [dh]);
  return /*#__PURE__*/_jsx(AuthPluginBase, {
    getLoginOptions: getLoginOptions,
    children: /*#__PURE__*/_jsx(UserPermissionsOverrideContext.Provider, {
      value: permissionsOverrides,
      children: children
    })
  });
}
var AuthPluginAnonymous = {
  Component,
  isAvailable: authHandlers => authHandlers.includes(AUTH_HANDLER_TYPE_ANONYMOUS)
};
export default AuthPluginAnonymous;
//# sourceMappingURL=AuthPluginAnonymous.js.map